import React, { useContext, useEffect, useState } from 'react';
import { Row, Menu, Col, App } from 'antd';
import { LogoutOutlined, PieChartOutlined } from '@ant-design/icons';
import { Link, useLocation, useNavigate, useParams } from 'react-router-dom';
import cl from './header.module.css';
import { AuthContext } from '../../Context/Auth.context';
import { useHttp } from '../../Hooks/Http.hook';

const items = [
    {
        label: 'Товары',
        key: 'products',
    },
    {
        label: 'Публикации',
        key: 'publications',
        children: [
            {
                label: 'Услуги',
                key: 'publication/service',
            },
            {
                label: 'Партнеры',
                key: 'directory/partner',
            },
            {
                label: 'Блог',
                key: 'publication/blog',
            },
        ],
    },
    {
        label: 'Справочники',
        key: 'directorys',
        children: [
            {
                label: 'Характеристики',
                key: 'directory/specifications',
            },
            {
                label: 'Шаблоны',
                key: 'directory/pattern',
            },
            {
                label: 'Теги',
                key: 'directory/tag',
            },
            {
                label: 'Ед. измерения',
                key: 'directory/unit',
            },
            {
                label: 'Баннеры',
                key: 'directory/banners',
            },
            {
                label: 'Бренды',
                key: 'directory/brand',
            },
            {
                label: 'Города',
                key: 'directory/city',
            },
            {
                label: 'Контакты',
                key: 'directory/contact',
            },
        ],
    },
];

const Header = () => {
    const { type } = useParams();
    const [current, setCurrent] = useState(type ?? 'products');
    const { pathname } = useLocation();
    const { logout } = useContext(AuthContext);
    const { request } = useHttp();
    const { notification } = App.useApp();

    const refreshDataToSite = async () => {
        await request(`/api/apply`)
            .then((res) => {
                if (res?.error) {
                    notification.error({ message: res.error.message });
                }
            })
            .catch(() =>
                notification.error({
                    message:
                        'Ошибка сервера. Попробуйте перезагрузить страницу.',
                })
            );
    };

    useEffect(() => {
        const findItem = (path, list) => {
            for (let i = 0; i < list.length; i += 1) {
                if (path.includes(list[i].key)) {
                    return list[i].key;
                } else if (list[i].children) {
                    const el = findItem(path, list[i].children);
                    if (el) {
                        return el;
                    }
                }
            }
            return null;
        };
        setCurrent(type ?? findItem(pathname, items) ?? 'products');
    }, [type, pathname]);
    const navigate = useNavigate();
    const clickHandler = (key) => {
        setCurrent(key.key);
        navigate(`/admin/${key.key}`);
    };
    return (
        <div className={cl.header}>
            <Row className={cl.headerContent}>
                <Row className={cl.toMain}>
                    <Link to="/admin">ТСК Антарес</Link>
                </Row>
                <Col style={{ width: 'calc(100% - 380px)' }}>
                    <Menu
                        className="admin-menu"
                        onClick={(key) => clickHandler(key)}
                        selectedKeys={[current]}
                        mode="horizontal"
                        items={items}
                    />
                </Col>
                <PieChartOutlined
                    title="Принудительно актуализирует данные на сайте, чтобы пользователи уведели правки по товарам"
                    onClick={() => {
                        refreshDataToSite();
                    }}
                    style={{
                        color: 'var(--white)',
                        cursor: 'pointer',
                        marginRight: '10px',
                    }}
                />
                <LogoutOutlined
                    title="Выйти из админ панели"
                    onClick={() => {
                        logout();
                        navigate('/');
                    }}
                    style={{ color: 'var(--white)', cursor: 'pointer' }}
                />
            </Row>
        </div>
    );
};

export default Header;
